import { ca } from '@cian/analytics';
import { debounce } from 'throttle-debounce';
import { CHART_DEBOUNCE_DELAY } from '../MarketTrendsContainer/utils/constants';

export function trackWhatIsMeanBtnClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click_sopr',
    label: 'PriceDemandOpenSpoiler',
  });
}

export function trackSupplyDemandTooltip() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Show_sopr',
    label: 'PriceDemandInfo',
  });
}

export const trackOnSupplyDemandChartHover = debounce(CHART_DEBOUNCE_DELAY, () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click',
    label: 'PriceDemandChartAction',
  });
});

/**
 * Трекаем доступность блока "Динамика спроса и предложения" на странице
 */
export function trackPriceDemandExist() {
  ca('teaser', {
    product: {
      name: 'price_demand_exist',
    },
  });
}
